import VerticalSwiper from './VerticalSwiper';

export default VerticalSwiper;
